import { Link } from 'react-router-dom';
import { useState, useRef, useEffect } from 'react';

function HeaderWrite() {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const containerRef = useRef(null);

    const closeDropdown = () => setIsDropdownOpen(false);

    useEffect(() => {
        if (!isDropdownOpen) return;

        const handleClickOutside = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                closeDropdown();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isDropdownOpen]);

    const handleDropdownClick = (e) => {
        if (e.target.closest('.header-dropdown-menu')) {
            closeDropdown();
        }
    };

    return (
        <div className="header-write" ref={containerRef}>
            <a
                className="btn btn-primary whiteBtn pc-only"
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            >
                <i className="icon icon-white icon-edit-pen"></i>
                <span>글쓰기</span>
            </a>
            <div
                className={`header-dropdown ${isDropdownOpen ? 'open' : ''}`}
                onClick={handleDropdownClick}
            >
                <div className="header-dropdown-tit">커뮤니티</div>
                <ul>
                    <li>
                        <Link to="/post/write?postType=PT011" className="header-dropdown-menu">
                            <img src="/static/img/assets/header-menu-01.png" />
                            <div className="header-dropdown-text">
                                <strong>자유광장</strong>
                                <p>어떤 주제든 자유롭게 이야기 나누는 공간입니다</p>
                            </div>
                        </Link>
                    </li>
                    <li>
                        <Link to="/post/write?postType=PT010" className="header-dropdown-menu">
                            <img src="/static/img/assets/header-menu-02.png" />
                            <div className="header-dropdown-text">
                                <strong>익명광장</strong>
                                <p>누구나 부담 없이 속마음을 털어놓는 공간입니다</p>
                            </div>
                        </Link>
                    </li>
                    <li>
                        <Link to="/post/write?postType=PT020" className="header-dropdown-menu">
                            <img src="/static/img/assets/header-menu-03.png" />
                            <div className="header-dropdown-text">
                                <strong>정보공유</strong>
                                <p>유용한 팁과 최신 소식을 함께 공유해요</p>
                            </div>
                        </Link>
                    </li>
                    <li>
                        <Link to="/post/write?postType=PT030" className="header-dropdown-menu">
                            <img src="/static/img/assets/header-menu-04.png" />
                            <div className="header-dropdown-text">
                                <strong>질문답변</strong>
                                <p>궁금한 점은 묻고, 경험으로 답해주세요</p>
                            </div>
                        </Link>
                    </li>
                </ul>

                {/* <div className="header-dropdown-tit">셀러존</div>
                <ul>
                    <li>
                        <Link to="/post/write?postType=PT012" className="header-dropdown-menu">
                            <img src="/static/img/assets/header-menu-05.png" />
                            <div className="header-dropdown-text">
                                <strong>셀러광장</strong>
                                <p>판매자들의 자유로운 소통 공간입니다</p>
                            </div>
                        </Link>
                    </li>
                    <li>
                        <Link to="/post/write?postType=PT021" className="header-dropdown-menu">
                            <img src="/static/img/assets/header-menu-06.png" />
                            <div className="header-dropdown-text">
                                <strong>셀러정보공유</strong>
                                <p>운영 노하우와 실전 정보를 나눠보세요</p>
                            </div>
                        </Link>
                    </li>
                    <li>
                        <Link to="/post/write?postType=PT031" className="header-dropdown-menu">
                            <img src="/static/img/assets/header-menu-07.png" />
                            <div className="header-dropdown-text">
                                <strong>셀러질문답변</strong>
                                <p>판매 활동 중 궁금한 점을 함께 해결해요</p>
                            </div>
                        </Link>
                    </li>
                </ul> */}

                <div className="header-dropdown-tit">마케팅존</div>
                <ul>
                    <li>
                        <Link to="/post/write?postType=PT001" className="header-dropdown-menu">
                            <img src="/static/img/assets/header-menu-08.png" />
                            <div className="header-dropdown-text">
                                <strong>마케팅서비스</strong>
                                <p>성장에 도움이 되는 서비스를 소개해보세요</p>
                            </div>
                        </Link>
                    </li>
                    {/* <li>
                        <Link to="/post/write?postType=PT050" className="header-dropdown-menu">
                            <img src="/static/img/assets/header-menu-09.png" />
                            <div className="header-dropdown-text">
                                <strong>자유홍보광고</strong>
                                <p>상품, 서비스, 이벤트를 자유롭게 홍보해보세요</p>
                            </div>
                        </Link>
                    </li> */}
                </ul>
            </div>
        </div>
    );
}

export default HeaderWrite;
